import React, { useMemo } from 'react';
import axiosInstance from '../../../../../services/Axios/axiosInstance';
import { formatUsers } from '../../../utils/formatForTables';
import { useParams } from 'react-router';
import AdminApi from '../../../../../services/Axios/AdminApi';

function useUsersTable() {
  const [usersData, setUsersData] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const { storeId } = useParams();
  const [pagination, setPagination] = React.useState({
    page: 1,
    total: 10,
  });

  React.useEffect(() => {
    AdminApi.getUsers({ page: pagination.page, storeId }).then((res) => {
      setPagination((p) => {
        if (p.page === res.page) {
          setUsersData(res?.data || []);
          return { page: res.page, total: res.total };
        }
        return p;
      });
    });
  }, [pagination.page]);

  const onUserCreated = () => {
    setPagination((p) => ({
      ...p,
      total: p.total + 1,
      page: p.total && p.total % 10 === 0 ? p.page + 1 : p.page,
    }));
    if (pagination.total === 0 || pagination.total % 10 !== 0)
      AdminApi.getUsers({ page: pagination.page, storeId }).then((res) => {
        setUsersData(res?.data || []);
      });
  };

  const onPageChange = (page) => {
    setPagination((p) => ({ ...p, page }));
  };

  const onSearchChange = (text) => {
    setPagination({
      page: 1,
      total: 10,
    });
    setSearchText(text);
  };

  const fortmatedUsers = useMemo(
    () => formatUsers(usersData, searchText, pagination.page),
    [usersData, searchText],
  );

  return {
    users: fortmatedUsers,
    searchText,
    isModalVisible,
    setIsModalVisible,
    pagination,
    setSearchText: onSearchChange,
    onPageChange,
    onUserCreated,
  };
}

export default useUsersTable;
